// Generated by scripts/generate-homepage-icons.cjs. Shapes come from the installed Lucide version.
import * as React from 'react'
import type { LucideProps } from 'lucide-react'
import { compactClassName } from './compact'
export type { LucideIcon } from 'lucide-react'

function icon(name: string) {
  const Icon = React.forwardRef<SVGSVGElement, LucideProps>(function SpriteIcon({ size = 24, strokeWidth, absoluteStrokeWidth, color, fill, className, style, children, ...props }, ref) {
    return <svg ref={ref} aria-hidden={props['aria-label'] || props['aria-labelledby'] || props.role || children ? undefined : true} width={size} height={size} viewBox="0 0 24 24" className={compactClassName(`lucide v3-svg ${className || ''}`)} style={{ ...(strokeWidth !== undefined ? { strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth } : {}), ...(color ? { stroke: color } : {}), ...(fill ? { fill } : {}), ...style }} {...props}><use href={`/homepage-october/icons.svg#${name}`} />{children}</svg>
  })
  Icon.displayName = name
  return Icon
}

export const Archive = icon('Archive')
export const ArrowLeft = icon('ArrowLeft')
export const ArrowRight = icon('ArrowRight')
export const ArrowUp = icon('ArrowUp')
export const ArrowUpRight = icon('ArrowUpRight')
export const Award = icon('Award')
export const BadgeCheck = icon('BadgeCheck')
export const BadgeDollarSign = icon('BadgeDollarSign')
export const BadgePercent = icon('BadgePercent')
export const Beer = icon('Beer')
export const Bell = icon('Bell')
export const BellRing = icon('BellRing')
export const BookOpen = icon('BookOpen')
export const Building2 = icon('Building2')
export const Calculator = icon('Calculator')
export const ChartLine = icon('ChartLine')
export const Check = icon('Check')
export const ChefHat = icon('ChefHat')
export const ChevronDown = icon('ChevronDown')
export const ChevronDownIcon = icon('ChevronDownIcon')
export const ChevronLeft = icon('ChevronLeft')
export const ChevronRight = icon('ChevronRight')
export const CircleCheck = icon('CircleCheck')
export const Cog = icon('Cog')
export const Columns2 = icon('Columns2')
export const Columns3 = icon('Columns3')
export const Cpu = icon('Cpu')
export const Cuboid = icon('Cuboid')
export const CupSoda = icon('CupSoda')
export const Droplet = icon('Droplet')
export const Droplets = icon('Droplets')
export const Eye = icon('Eye')
export const FileText = icon('FileText')
export const GitCompareArrows = icon('GitCompareArrows')
export const GraduationCap = icon('GraduationCap')
export const Heart = icon('Heart')
export const Hourglass = icon('Hourglass')
export const House = icon('House')
export const Info = icon('Info')
export const LayoutPanelTop = icon('LayoutPanelTop')
export const Leaf = icon('Leaf')
export const Link2 = icon('Link2')
export const ListChecks = icon('ListChecks')
export const Mail = icon('Mail')
export const MapPin = icon('MapPin')
export const Maximize2 = icon('Maximize2')
export const Menu = icon('Menu')
export const Minimize2 = icon('Minimize2')
export const PackageSearch = icon('PackageSearch')
export const Palette = icon('Palette')
export const PanelBottom = icon('PanelBottom')
export const PanelTop = icon('PanelTop')
export const RectangleVertical = icon('RectangleVertical')
export const Refrigerator = icon('Refrigerator')
export const RotateCcw = icon('RotateCcw')
export const Ruler = icon('Ruler')
export const Scale = icon('Scale')
export const Search = icon('Search')
export const ShieldAlert = icon('ShieldAlert')
export const ShieldCheck = icon('ShieldCheck')
export const SlidersHorizontal = icon('SlidersHorizontal')
export const Snowflake = icon('Snowflake')
export const Sparkles = icon('Sparkles')
export const Store = icon('Store')
export const Tag = icon('Tag')
export const Tags = icon('Tags')
export const Timer = icon('Timer')
export const Trash2 = icon('Trash2')
export const TrendingDown = icon('TrendingDown')
export const TrendingUp = icon('TrendingUp')
export const Users = icon('Users')
export const VolumeX = icon('VolumeX')
export const Warehouse = icon('Warehouse')
export const Wine = icon('Wine')
export const Wrench = icon('Wrench')
export const X = icon('X')
export const Zap = icon('Zap')
